import { Container } from '@material-ui/core';
import { useContext } from 'react';
import codings from '../../assets/lottie/coding.json';
import { ThemeContext } from '../../contexts/ThemeContext';
import { aboutData } from '../../data/aboutData';
import AnimationLottie from '../Animation';
import './About.css';



function About() {

    const { theme } = useContext(ThemeContext);
    return (
        <div style={{ backgroundColor: theme.secondary, position: 'relative' }}>
            <Container className="about" id="about">
                <div className="about-body">
                    <div className="about-description" style={{ '--primary-color': theme.primary, '--secondary-color': theme.secondary, '--gradient-end': theme.tertiary }}>
                        <h2 style={{ color: theme.primary }}>{aboutData.title}</h2>
                        <p style={{ color: theme.tertiary }}>
                            {aboutData.description1}
                            <br />
                            <br />
                            {aboutData.description2.split('**').map((text, index) =>
                                index % 2 === 1 ? (
                                    <span key={index} className='highlight' style={{ color: theme.primary }}>
                                        {text}
                                    </span>
                                ) : (
                                    text
                                )
                            )}
                        </p>
                    </div>
                    <div className="about-animation">
                        <AnimationLottie animationPath={codings} />
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default About
